<template>
  <div class="nft_wrapper full purchaseform" id="myNft">
    <!-- title -->
    <div class="main_top">
      <h1>
        <img src="images/basic/icon/back-w.svg" onclick="history.back()" class="back" />
        NFT 구매하기
      </h1>
      <a class="h1_div"> </a>
    </div>
    <div class="dashboard">
       <div class="div_padding"></div>
      <div class="text">
        <h2>NFT 한정판매</h2>
        <div class="detail">
          <p>NFT 구매 후 보유 하고만 있어도
광고 보상을 제공하며 마켓에서 언제든 
판매가 가능!</p>
        </div>
      </div>
      <div class="wall"></div>
    </div>
   
    <div class="stat">
      <ul class="list horizon">
        <li class="items">
          <h4>NFT 상품 선택</h4>
          <ul class="item">
            <li class="line1px-bottom">
              <div class="thumb">
                <img src="images/basic/img/nft-roulette.png" alt="">
              </div>
              <div class="text">
                <h3>NFT Holder Roulette</h3>
                <p class="price">₩ 20,000,000</p>
                <p class="select">
                  <select name="" id="">
                    <option value="0">0</option>
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                    <option value="5">5</option>
                    <option value="6">6</option>
                    <option value="7">7</option>
                    <option value="8">8</option>
                    <option value="9">9</option>
                    <option value="10">10</option>
                  </select>
                  <span class="remain">999 / 1,000</span>
                </p>
              </div>
            </li>
            <li class="line1px-bottom">
              <div class="thumb">
                <img src="images/basic/img/nft-roulette-b.png" alt="">
              </div>
              <div class="text">
                <h3>NFT Holder Roulette</h3>
                <p class="price">₩ 100,000,000</p>
                <p class="select">
                  <select name="" id="">
                    <option value="0">0</option>
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                    <option value="5">5</option>
                    <option value="6">6</option>
                    <option value="7">7</option>
                    <option value="8">8</option>
                    <option value="9">9</option>
                    <option value="10">10</option>
                  </select>
                  <span class="remain">999 / 1,000</span>
                </p>
              </div>
            </li>
            <li class="line1px-bottom">
              <div class="thumb">
                <img src="images/basic/img/nft-slot.png" alt="">
              </div>
              <div class="text">
                <h3>NFT Holder Slot</h3>
                <p class="price">₩ 20,000,000</p>
                <p class="select">
                  <select name="" id="">
                    <option value="0">0</option>
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                    <option value="5">5</option>
                    <option value="6">6</option>
                    <option value="7">7</option>
                    <option value="8">8</option>
                    <option value="9">9</option>
                    <option value="10">10</option>
                  </select>
                  <span class="remain">999 / 1,000</span>
                </p>
              </div>
            </li>
            <li class="line1px-bottom">
              <div class="thumb">
                <img src="images/basic/img/nft-slot-b.png" alt="">
              </div>
              <div class="text">
                <h3>NFT Holder Slot</h3>
                <p class="price">₩ 100,000,000</p>
                <p class="select">
                  <select name="" id="">
                    <option value="0">0</option>
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                    <option value="5">5</option>
                    <option value="6">6</option>
                    <option value="7">7</option>
                    <option value="8">8</option>
                    <option value="9">9</option>
                    <option value="10">10</option>
                  </select>
                  <span class="remain">999 / 1,000</span>
                </p>
              </div>
            </li>
            <li class="line1px-bottom">
              <div class="thumb">
                <img src="images/basic/img/nft-dice.png" alt="">
              </div>
              <div class="text">
                <h3>NFT Holder Dice</h3>
                <p class="price">₩ 20,000,000</p>
                <p class="select">
                  <select name="" id="">
                    <option value="0">0</option>
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                    <option value="5">5</option>
                    <option value="6">6</option>
                    <option value="7">7</option>
                    <option value="8">8</option>
                    <option value="9">9</option>
                    <option value="10">10</option>
                  </select>
                  <span class="remain">999 / 1,000</span>
                </p>
              </div>
            </li>
            <li>
              <div class="thumb">
                <img src="images/basic/img/nft-dice-b.png" alt="">
              </div>
              <div class="text">
                <h3>NFT Holder Dice</h3>
                <p class="price">₩ 100,000,000</p>
                <p class="select">
                  <select name="" id="">
                    <option value="0">0</option>
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                    <option value="5">5</option>
                    <option value="6">6</option>
                    <option value="7">7</option>
                    <option value="8">8</option>
                    <option value="9">9</option>
                    <option value="10">10</option>
                  </select>
                  <span class="remain">999 / 1,000</span>
                </p>
              </div>
            </li>
          </ul>
        </li>
        
      </ul>
      <ul class="list horizon payment">
        <h4>지불방식 선택</h4>
        <li class="line1px-bottom">
          <dl>
            <dt><input type="radio" name="payment" id="cash" checked><label for="cash">일시납부</label></dt>
            <dd>
              <p>더해앱 이용 회원 모두 구매 가능</p>
            </dd>
            <dt><input type="radio" name="payment" id="installment"><label for="installment">할부납부</label></dt>
            <dd>
              <p>추천인 10명 이상이며 구매시점 더해앱 FUS코인 20,000개 이상 보유한 회원 구매 가능</p>
              <p class="ext">중도금은 수익금으로 자동 납부 가능하며, 계약만료일(1년) 
이내에 잔금 완납을 완료하셔야 합니다.</p>
            </dd>
          </dl>
        </li>
        <li class="line1px-bottom">
          <h4>구매하실 NFT</h4>
          <div class="text single"><p>200만 2개, 1,000만 1개 </p></div>
        </li>
        <li class="line1px-bottom">
          <h4>구매하실 금액</h4>
          <div class="text single"><p>₩ 14,000,000 </p><p class="price">5120293.021 TRX </p></div>
        </li>
        <li class="line1px-bottom addr">
          <h4>입금 TRX 주소</h4>
          <div class="text single"><p>1KJ7Kb5e88o6U4L69Zym5kMPMVjEwrbAsh</p><a href="#"><img src="images/basic/icon/copy.svg" alt=""></a></div>
        </li>
        <li class="line1px-bottom">
          <h4>입금 하실 TRX</h4>
          <div class="text single"><p><img src="images/basic/icon/tron.svg" alt=""> 5120293.021 TRX </p></div>
        </li>
        <li class="line1px-bottom">
          <h4>추천인 코드(선택)</h4>
          <div class="text single"><input type="text" placeholder="추천인이 있으시면 추천인코드를 입력하세요"></div>
        </li>
        <li>
          <div class="exp">NFT 판매금액을 현시간 기준으로 TRX로 환산한 금액을
          24시간 이내에 입금 주소에 입금하시면 구매가 완료됩니다.<br>
          구매하신 내역은 <u>내 NFT</u>에서 확인가능합니다.</div>
        </li>
      </ul>  
    </div>
    <div class="btn_full"><a href="#">구매하기</a></div>     
  </div>
</template>

<script>
import $ from 'jquery'
export default {
  mounted() {
    $(document).ready(function(){
      $(".select select").change(function(){
          var quan = $(this).val();
          var num = Number(quan);
          if(num>0) {
            $(this).addClass('ed');
          } else {
            $(this).removeClass('ed');
          }
        });
    });
    $(window).scroll(function(){ 
      var height = $(document).scrollTop(); //실시간으로 스크롤의 높이를 측정
      if(height > 0){ 
        $('body').addClass('scrolled'); 
      }else if(height == 0){ 
        $('body').removeClass('scrolled'); 
      } 
    });
  },
}
</script>

<style scoped>

</style>